export const NANAIMO = "Nanaimo";
export const PRINCE_GEORGE = "PG";

export const LOCATIONS = [NANAIMO, PRINCE_GEORGE] as const;
export type Location = (typeof LOCATIONS)[number];

export const isLocation = (value: unknown): value is Location => {
  return !!LOCATIONS.find((location) => location === value);
};
